// components/AuthGate.jsx

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUser } from "utilities/redux/slices/authSlice";
import { Button, Result, Spin } from "antd";
import config from "config";

// This component holds the logic for checking auth status.
const AuthGate = ({ children }) => {
  const dispatch = useDispatch();
  const { status, error, data } = useSelector((state) => state.auth);
  // On initial component mount, dispatch the action to fetch user data.
  useEffect(() => {
    // We only want to fetch the user if the status is 'idle'.
    if (status === "idle") {
      dispatch(fetchUser());
    }
  }, [status, dispatch]);

  // This effect sets up an interval to re-check authentication every 5 minutes.
  useEffect(() => {
    // Only start polling if the user is successfully authenticated.
    if (status === "succeeded") {
      const intervalId = setInterval(() => {
        dispatch(fetchUser());
      }, 300000); // 5 minutes in milliseconds

      // The cleanup function clears the interval when the component
      // unmounts or before the effect re-runs (e.g., if status changes).
      return () => {
        clearInterval(intervalId);
      };
    }
  }, [status, dispatch]);
  if (status === "succeeded" || (status === "loading" && data?.initials)) {
    return children;
  }

  // If the async thunk is running or hasn't started, show a loading indicator.
  if (status === "loading" || status === "idle") {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  if (status === "failed") {
    const handleLoginRedirect = () => {
      window.location.href = `${config.authUrl}/login?redirect=${window.location.href}`;
    };

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Result
          status="403" // Using 403 status for "Forbidden/Not Authenticated"
          title="Authentication Required"
          subTitle={
            error || "Sorry, your session has expired or you are not logged in."
          }
          extra={
            <Button type="primary" onClick={handleLoginRedirect}>
              Go to Login
            </Button>
          }
        />
      </div>
    );
  }



  
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Spin size="large" />
    </div>
  );
};

export default AuthGate;
